export class XmlParserUtil
{
    public static sniffIsXML(text:string):boolean
    {
        if( !text || text.length === 0 )
            return false;

        const detectSubset = text.substring(0,Math.min(100,text.length));

        return detectSubset.trim().startsWith("<?xml");
    }

    // Adapted from: https://davidwalsh.name/convert-xml-json
    public static parseXml(xmlString:string):any
    {
        const rootXmlNode = new DOMParser().parseFromString(xmlString,"text/xml")
        return XmlParserUtil._xmlNodeToJson(rootXmlNode);
    }

    public static toXml(obj:any):string
    {
        let xml = '';

        for( const prop in obj )
        {
            xml += obj[prop] instanceof Array ? '' : '<' + prop;

            let attributes = [];
            if( !!obj[prop]['@attributes'] )
            {
                const jsonAttributes = obj[prop]['@attributes'];
                for( const attribute in jsonAttributes )
                    attributes.push(`${attribute}="${jsonAttributes[attribute]}"`)

                xml += attributes.length > 0 ? ' ' + attributes.join(' ') : '';
            }
            xml += obj[prop] instanceof Array ? '' : '>';

            if( obj[prop] instanceof Array )
            {
                for( const item of obj[prop] )
                {
                    xml += XmlParserUtil.toXml({[prop]: item});
                }
            }
            else if( typeof obj[prop] == 'object' )
            {
                if( prop !== '@attributes' )
                    xml += XmlParserUtil.toXml(new Object(obj[prop]));
            }
            else
            {
                xml += obj[prop];
            }

            if( xml === '<@attributes>' )
                xml = '';
            else if (!(obj[prop] instanceof Array))
                xml += '</' + prop + '>';
        }

        return xml;
    }

    private static _xmlNodeToJson(xmlNode:any):any
    {
        // Create the object to return
        var obj = {};

        if( xmlNode.nodeType == 1 ) // XML 'element' node
        {
            // do attributes
            if (xmlNode.attributes.length > 0)
            {
                obj["@attributes"] = {};

                for (var j = 0; j < xmlNode.attributes.length; j++)
                {
                    var attribute = xmlNode.attributes.item(j);
                    obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
                }
            }
        }
        else if( xmlNode.nodeType == 3 ) // XML '#text' node
        {
            obj = xmlNode.nodeValue;
        }

        // traverse child XML nodes
        if( xmlNode.hasChildNodes() )
        {
            if( XmlParserUtil._hasSingleXmlTextNodeChild(xmlNode) )
            {
                const item = xmlNode.childNodes.item(0);
                obj[item.nodeName] = item.nodeValue;
            }
            else
            {
                for( let i = 0; i < xmlNode.childNodes.length; i++ )
                {
                    const item = xmlNode.childNodes.item(i);

                    // we cut the support of mixed content here, to save the ability of two-way conversion between XML and JSON.
                    if( item.nodeType === 3 )
                        continue;

                    const nodeName = item.nodeName;

                    if( typeof(obj[nodeName]) == 'undefined' )
                    {
                        obj[nodeName] = this._xmlNodeToJson(item);
                    }
                    else
                    {
                        if( typeof(obj[nodeName].push) == "undefined" )
                        {
                            const old = obj[nodeName];

                            obj[nodeName] = [];
                            obj[nodeName].push(old);
                        }

                        obj[nodeName].push(this._xmlNodeToJson(item));
                    }
                }
            }
        }

        return obj;
    }

    private static _hasSingleXmlTextNodeChild(xmlNode):boolean
    {
        return  xmlNode &&
            xmlNode.childNodes &&
            xmlNode.childNodes.length === 1 &&
            xmlNode.childNodes[0].nodeType === 3 /* #text */;
    }

    public static prettifyXml(sourceXml:string)
    {
        const xmlDoc = new DOMParser().parseFromString(sourceXml, 'application/xml');
        const xsltDoc = new DOMParser().parseFromString([
            // describes how we want to modify the XML - indent everything
            '<xsl:stylesheet xmlns:xsl="http://www.w3.org/1999/XSL/Transform">',
            '  <xsl:strip-space elements="*"/>',
            '  <xsl:template match="para[content-style][not(text())]">',
            '    <xsl:value-of select="normalize-space(.)"/>',
            '  </xsl:template>',
            '  <xsl:template match="node()|@*">',
            '    <xsl:copy><xsl:apply-templates select="node()|@*"/></xsl:copy>',
            '  </xsl:template>',
            '  <xsl:output indent="yes"/>',
            '</xsl:stylesheet>',
        ].join('\n'), 'application/xml');

        const xsltProcessor = new XSLTProcessor();    
        xsltProcessor.importStylesheet(xsltDoc);
        const resultDoc = xsltProcessor.transformToDocument(xmlDoc);
        const resultXml = new XMLSerializer().serializeToString(resultDoc);
        return resultXml;
    }
}
